/**
 * lib/csv.js — minimal CSV parse/serialise for the Phase C importers.
 *
 * Handles the only quoting rule the spec needs: a field wrapped in
 * double-quotes can contain commas and escaped quotes (`""`). No
 * external dependency — keeps the bundle lean.
 */

/**
 * Parse a CSV string into `{ headers: string[], rows: string[][] }`.
 * Trims trailing newlines; ignores fully blank lines.
 */
export function parseCsv(text) {
  const rows = [];
  let field = "";
  let row = [];
  let inQuotes = false;
  const src = text.replace(/\r\n?/g, "\n");

  for (let i = 0; i < src.length; i++) {
    const c = src[i];
    if (inQuotes) {
      if (c === '"') {
        if (src[i + 1] === '"') { field += '"'; i++; }
        else inQuotes = false;
      } else {
        field += c;
      }
    } else {
      if (c === '"') inQuotes = true;
      else if (c === ",") { row.push(field); field = ""; }
      else if (c === "\n") { row.push(field); rows.push(row); field = ""; row = []; }
      else field += c;
    }
  }
  // Flush trailing cell / row (file w/o trailing newline)
  if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }

  // Drop blank rows
  const filtered = rows.filter((r) => !(r.length === 1 && r[0].trim() === ""));
  if (filtered.length === 0) return { headers: [], rows: [] };

  const headers = filtered[0].map((h) => h.trim());
  return { headers, rows: filtered.slice(1) };
}

/** Serialise an array of objects to a CSV string given a column list. */
export function toCsv(rows, columns) {
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v);
    if (s.includes(",") || s.includes('"') || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const head = columns.join(",");
  const body = rows.map((r) => columns.map((c) => escape(r[c])).join(",")).join("\n");
  return `${head}\n${body}`;
}

/** Trigger a browser download for a string-typed file. */
export function downloadCsv(filename, csvString) {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
